import React, { useEffect, useState } from "react";
import { LayoutDashboard } from "lucide-react";
import CompanyTable from "../../components/Admin/Company/CompanyTable";
import {
  getAllCompanies,
  deleteCompany,
} from "../../services/companyService";
import { toast } from "react-hot-toast";

const CompanyManagement = () => {
  const [companies, setCompanies] = useState([]);

  const fetchCompanies = async () => {
    const response = await getAllCompanies();
    if (response.status === "success") {
      setCompanies(response.data);
    } else {
      console.error("Failed to fetch companies:", response);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);


  const handleDelete = async (companyId) => {
    const response = await deleteCompany(companyId);
    if (response.status === "success") {
      toast.success("Company Deleted Successfully");
      fetchCompanies();
    } else {
      toast.error("Failed to delete company.");
    }
  };

  return (
    <div>
      {/* <div className="flex items-center gap-4 mb-6">
        <LayoutDashboard className="w-5 h-5 text-[#27ade3]" />
        <h1 className="text-2xl font-semibold text-[#1a325d]">Admin Panel</h1>
      </div> */}

      <CompanyTable
        companies={companies}
        onDelete={handleDelete}
        onCompanyAdded={fetchCompanies}
      />
    </div>
  );
};

export default CompanyManagement;
